import { CurrencyEnum } from '../../enums/common/currency.enum'
import { StaffPositionEnum } from '../../enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../enums/staff/staff-qualifications.enum'
import { ContractLight } from './contract'

export class ContractProperties {
  /**
   * Get the date range of the contract
   * @param contract - The contract to get the date range from
   * @returns The date range of the contract in case of a mission to staff, undefined otherwise
   */
  static getDateRange(
    contract: ContractLight
  ): { startDate: string; endDate: string } | undefined {
    if (contract.missionToStaffs.length > 0) {
      const { missionTracking } = contract.missionToStaffs[0]
      return { startDate: missionTracking.startDate, endDate: missionTracking.endDate }
    }

    if (contract.affectedStaff) {
      const { startDate, endDate } = contract.affectedStaff.staffRequest
      if (startDate && endDate) return { startDate, endDate }
    }
  }

  static getStaffPosition(contract: ContractLight): StaffPositionEnum | undefined {
    if (contract.missionToStaffs.length > 0) return StaffPositionEnum.AAT
    if (contract.affectedStaff) return contract.affectedStaff.staff.position
  }

  static getCountryCode(contract: ContractLight): string | undefined {
    if (contract.affectedStaff) return contract.affectedStaff.staffRequest.country?.code
  }

  static getStaffQualification(contract: ContractLight): StaffQualificationEnum | undefined {
    if (contract.affectedStaff) return contract.affectedStaff.staffRequest.qualification
  }

  /**
   * Currency the contract remuneration is expressed in.
   * Mission (AAT) contracts are always in EUR; affected-staff contracts follow the
   * currency the backend derived from the staff qualification (GBP for foreign staff).
   */
  static getCurrency(contract: ContractLight): CurrencyEnum {
    if (contract.affectedStaff) return contract.affectedStaff.currency
    return CurrencyEnum.EUR
  }

  static getNetRemunerationBeforePASE(contract: ContractLight): number | undefined {
    if (contract.missionToStaffs.length > 0)
      return contract.missionToStaffs.reduce((acc, curr) => acc + (curr.pay ?? 0), 0)

    if (contract.affectedStaff) return contract.affectedStaff.salary
  }
}
